<template>
    <div style="height: 100%;">
        <el-row :gutter="20" class="container">
            <el-col :span="24" :xs="24" class="container" style="flex-direction: column;border-width: 0;padding-top: 25px;">
                    <el-form :model="queryParams.param" ref="queryForm" :inline="true" label-position="right" v-show="showSearch" label-width="110px">
                                <el-form-item :label="columnInfo.type.label" prop="type">
                                        <enum-dict-select v-model="queryParams.param.type" placeholder="请选择" dict-code="notificationType" module-name="system" clearable size="small"></enum-dict-select>
                                </el-form-item>
                                <el-form-item :label="columnInfo.priority.label" prop="priority">
                                        <enum-dict-select v-model="queryParams.param.priority" placeholder="请选择" dict-code="notificationPriority" module-name="system" clearable size="small"></enum-dict-select>
                                </el-form-item>
                                <el-form-item :label="columnInfo.category.label" prop="category">
                                        <el-input v-model="queryParams.param.category" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <el-form-item :label="columnInfo.title.label" prop="title">
                                        <el-input v-model="queryParams.param.title" placeholder="请输入内容" size="small" clearable></el-input>
                                </el-form-item>
                                <el-form-item :label="columnInfo.state.label" prop="state">
                                        <enum-dict-select v-model="queryParams.param.state" dict-code="state" module-name="system" size="small" clearable></enum-dict-select>
                                </el-form-item>
                        <el-form-item>
                            <el-button type="primary" icon="el-icon-search" size="small" @click="handleTableSearch">搜索</el-button>
                            <el-button icon="el-icon-refresh" size="small" @click="clickReset">重置</el-button>
                        </el-form-item>
                    </el-form>
                    <el-row :gutter="10" style="margin-bottom:13px;margin-right: 1px">
                        <el-col :span="1.5">
                            <el-button
                                    type="primary"
                                    plain
                                    icon="el-icon-plus"
                                    size="small"
                                    @click="clickAdd"
                                    v-permissionDisabled="'system:notification:create'"
                            >发送通知</el-button>
                        </el-col>
                        <el-col :span="1.5">
                            <excel-export-plus file-name="通知中心" module-name="system" table-name="notification" :select-list="selectList" :permission-code="'system:notification:export'"></excel-export-plus>
                        </el-col>
                        <right-toolbar-plus :showSearch.sync="showSearch" @queryTable="handleTableSearch"
                                            :columnInfo="columnInfo" @redoTableLayout="redoTableLayout"></right-toolbar-plus>
                    </el-row>
                    <div class="main">
                        <div class="table">
                            <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                                      @selection-change="handleSelectionChange" height="100%" :header-cell-style="{background:'#ECF5FF'}">
                                <el-table-column align="center" type="selection" width="55"/>
                                        <af-table-column align="center" prop="type" :label="columnInfo.type.label" v-if="columnInfo.type.visible" width="100">
                                          <template v-slot="scope">
                                            <enum-dict-label v-model="scope.row.type" module-name="system" dict-code="notificationType" show-tag></enum-dict-label>
                                          </template>
                                        </af-table-column>
                                        <af-table-column align="center" prop="priority" :label="columnInfo.priority.label" v-if="columnInfo.priority.visible" width="100">
                                          <template v-slot="scope">
                                            <enum-dict-label v-model="scope.row.priority" module-name="system" dict-code="notificationPriority" show-tag></enum-dict-label>
                                          </template>
                                        </af-table-column>
                                         <af-table-column align="center" prop="category" :label="columnInfo.category.label" v-if="columnInfo.category.visible"></af-table-column>
                                         <af-table-column align="center" prop="title" :label="columnInfo.title.label" v-if="columnInfo.title.visible"></af-table-column>
                                          <af-table-column align="center" prop="fromUserId" :label="columnInfo.fromUserId.label" v-if="columnInfo.fromUserId.visible" width="120">
                                            <template v-slot="scope">
                                              <user-name-label v-model="scope.row.fromUserId"></user-name-label>
                                            </template>
                                          </af-table-column>
                                          <af-table-column align="center" prop="toUserIds" :label="columnInfo.toUserIds.label" v-if="columnInfo.toUserIds.visible" width="200">
                                            <template v-slot="scope">
                                              <multi-user-label v-model="scope.row.toUserIds"></multi-user-label>
                                            </template>
                                          </af-table-column>
                                         <af-table-column align="center" prop="sendTime" :label="columnInfo.sendTime.label" v-if="columnInfo.sendTime.visible" width="180"></af-table-column>
                                        <el-table-column align="center" prop="state" :label="columnInfo.state.label" v-if="columnInfo.state.visible" width="100">
                                          <template v-slot="scope">
                                            <enum-dict-label v-model="scope.row.state" module-name="system" dict-code="state"
                                                             show-tag></enum-dict-label>
                                          </template>
                                        </el-table-column>
                                <af-table-column align="center" label="操作" width="200" fixed="right">
                                    <template v-slot="scope">
                                      <el-button @click="clickEdit(scope.row)" type="primary" size="mini" v-permissionDisabled="'system:notification:update'">编辑</el-button>
                                      <el-button @click="clickDel(scope.row)" type="danger" size="mini" v-permissionDisabled="'system:notification:remove'">删除</el-button>
                                    </template>
                                </af-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="bottom">
                        <Pagination :totalCount="totalCount" :pageSize="pageSize" :currPage="currPage" :pageSizes="pageSizes" :selectList="selectList"
                                      @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange"
                                      @handleDelAll="handleDelAll" @handleState="handleState"/>
                    </div>
            </el-col>
        </el-row>
        <NotificationForm :relationDialogVisible.sync="dialogVisible" :showData="editData" :isAdd="isAdd"/>
    </div>
</template>

<script>
    import NotificationForm from "./NotificationForm"
    import Pagination from "@/components/widget/Pagination"
    import MultiUserLabel from "@/components/label/MultiUserLabel"
    import UserNameLabel from "@/components/label/UserNameLabel"
    import {mapState, mapMutations, mapActions} from "vuex"
    import {updateState, removeData} from "@/api/baseApi"

    export default {
        name: 'Notification',
        components: {
            Pagination,
            NotificationForm,
            MultiUserLabel,
            UserNameLabel
        },
        data() {
            return {
                showSearch: true,
                selectList: [],
                pageSize: 10,
                currPage: 1,
                pageSizes: [10, 20, 40, 80],
            }
        },
        computed: {
            ...mapState({
                tableData: state => state.system.notification.tableData,
                totalCount: state => state.system.notification.totalCount,
                options: state => state.system.notification.options,
                columnInfo: state => state.system.notification.columnInfo,
                queryParams: state => state.system.notification.queryParams,
                dateRange: state => state.system.notification.dateRange,
                formInfo: state => state.system.notification.formInfo,
                moreButtonProps: state => state.system.notification.moreButtonProps,
                dialogVisible: state => state.system.notification.formInfo.dialogVisible,
                isAdd: state => state.system.notification.formInfo.isAdd,
                editData: state => state.system.notification.formInfo.editData,
            })
        },
        created() {
            this.handleTableSearch()
        },
        methods: {
            ...mapMutations({
                clickEdit: 'system/notification/clickEdit',
                clickAdd: 'system/notification/clickAdd',
            }),
            ...mapActions({
                handleTableSearch: 'system/notification/handleTableSearch',
                handleDel: 'system/notification/handleDel',
            }),
            handleSizeChange(val) {
                this.pageSize = val
                this.queryParams.limit = val
                this.handleTableSearch()
            },
            handleCurrentChange(val) {
                this.currPage = val
                this.queryParams.currPage = val
                this.handleTableSearch()
            },
            handleSelectionChange(val) {
                this.selectList = val
            },
            handleDelAll(array) {
                removeData("system", "notification", array).then(res => {
                    if (res.code === 200) {
                        this.refreshData()
                    }
                })
            },
            handleState(array, state) {
                updateState("system", "notification", array, state).then(res => {
                    if (res.code === 200) {
                        this.refreshData()
                    }
                })
            },
            clickReset() {
                this.$refs.queryForm.resetFields()
                this.handleTableSearch()
            },
            refreshData() {
                this.handleTableSearch()
            },
            redoTableLayout() {
            }
        }
    }
</script>

<style lang="less" scoped>
    @import url('~@/assets/style/index.less');
</style>
